export default "__VITE_ASSET__orN0CFPN__"